/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactEventConfig } from './ContactEventConfig.js';
import {
    ContactEventConfigFromJSON,
    ContactEventConfigFromJSONTyped,
    ContactEventConfigToJSON,
} from './ContactEventConfig.js';

/**
 * 
 * @export
 * @interface ScriptStepSentenceResponse
 */
export interface ScriptStepSentenceResponse {
    /**
     * 
     * @type {ContactEventConfig}
     * @memberof ScriptStepSentenceResponse
     */
    data?: ContactEventConfig;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepSentenceResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepSentenceResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptStepSentenceResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptStepSentenceResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptStepSentenceResponse interface.
 */
export function instanceOfScriptStepSentenceResponse(value: object): boolean {
    return true;
}

export function ScriptStepSentenceResponseFromJSON(json: any): ScriptStepSentenceResponse {
    return ScriptStepSentenceResponseFromJSONTyped(json, false);
}

export function ScriptStepSentenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptStepSentenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactEventConfigFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptStepSentenceResponseToJSON(value?: ScriptStepSentenceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactEventConfigToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

